import axios from "axios";
import SVG from 'react-inlinesvg';
import "./ImageUploader.scss";
import React, { useContext, useEffect, useRef } from "react";
import { useState } from "react";
import ApiService from "../../Core/Service/ApiService";
import { MDBBtn, MDBIcon, MDBProgress, MDBProgressBar, MDBSpinner } from "mdb-react-ui-kit";
import { getImageUrl } from "../../Utils/utils";


const ImageUploader = React.memo(props => {
    const photoRef = useRef(null);
    const fileInputRef = useRef(null);
    const [uploading, setUploading] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [uploadComplete, setUploadComplete] = useState(false);
    const [deleting, setDeleting] = useState(false);
    const [pendingPreview, setPendingPreview] = useState(null);

const onImageClick = (e) => {
        e.preventDefault();
        fileInputRef.current.click();
    }

    const onImageSelected = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        if (!file.type.startsWith('image/')) {
            toast.error("Please select the image file");
            return;
        }

        let reader = new FileReader();
        reader.onload = function () {
            setPendingPreview(reader.result);
        }
        reader.readAsDataURL(file);

        if (props.onFileSelected) {
            props.onFileSelected(props.id, file);
        } else {
            handleUpload(file);
        }
    }

    const handleUpload = (file) => {
        setUploadProgress(0);
        setUploading(true);
        setUploadComplete(false);

        const formData = new FormData();
        formData.append('file', file);
        formData.append('folder', props.folder)
        try {
            ApiService.post('/media/upload', formData, { 'Content-Type': 'multipart/form-data' }, onUploadProgress).then(response => {
                setUploadComplete(true);
                props.onImageUploaded && props.onImageUploaded(props.id, response.data.file);
            }).finally(() => {
                setUploading(false);
                setUploadProgress(0);
            })
        } catch (error) {
            console.error(error);
        }
    }

    const handleDelete = async () => {
        setDeleting(true);
        ApiService.post(`/media/delete`, { file: props.defaultSrc }).then(response => {
            props.onImageDeleted && props.onImageDeleted(props.id);
            setUploadComplete(false);
            setPendingPreview(null);
        }).finally(() => {
            setDeleting(false);
        })
    }

    const onUploadProgress = (evt) => {
        setUploadProgress(parseInt(evt.loaded * 100 / evt.total))
    }

    return <div className={`image-uploader d-flex justify-content-center ${props.className ?? ''}`}>
        <img
            src={pendingPreview || getImageUrl(props.defaultSrc)}
            className={`${props.imgClassName}`}
            onClick={onImageClick}
            ref={photoRef}
            style={{
                cursor: 'pointer',
                maxWidth: '100%',
            }}
        />
        <input type="file"
            className="hidden"
            ref={fileInputRef}
            onChange={onImageSelected}
            accept=".jpg, .jpeg, .png"
            style={{ display: 'none' }}
        />
        {props.defaultSrc && (
            <div className="delete-btn">
                <MDBBtn color="none" tag="a" onClick={handleDelete}>
                    {deleting && <MDBSpinner size="sm" />}
                    {!deleting && <MDBIcon far icon="trash-alt" size="lg" color="danger" />}
                </MDBBtn>
            </div>
        )}
        {uploadProgress > 0 && (
            <MDBProgress className="upload-progress">
                <MDBProgressBar width={uploadProgress} valuemin={0} valuemax={100} bgColor="success" />
            </MDBProgress>
        )}
        {uploadComplete && (
            <div className="upload-complete">
                <SVG src="/img/icons/check.svg" width={40} height={40} fill='green' />
            </div>
        )}
    </div>
})

export default ImageUploader;